import AbstractRequestTask from "../AbstractRequestTask";
import Device from "../../../devices/device";
import Launcher from '../../apa/Launcher';
import settings from "../../../devices/all/settings";
import { Resilence } from "../../../AAF/Resilence/main";
const { isPTVUSer } = Resilence;

class authdeviceV1Task extends AbstractRequestTask {
    constructor(params) {
        super();
    }

    getHeaders() {
        return {};
    }

    getUrl() {
        if (settings.fake_url_mockoon) {
            return `${settings.fake_url_mockoon}/services/user/v1/authdevice`;
        } else {
            const http = "https://";
            const url = Launcher.get("akamai_mfwk");
            return `${http}${url}/services/user/v1/authdevice`;
        }
    }

    getParams() {
        const params = super.getParams();
        const isIPTV = isPTVUSer();
        console.log('[authDevice V1 params]:: ', params, isIPTV);
        const extra_params = {};
        const { serial_id } = Device.getDevice().getConfig();
        
        extra_params.serial_id = serial_id;
        
        console.log('[authDevice V1 params serialid]:: ', serial_id);
        delete params.HKS;
        delete params.api_version;
        delete params.format;

        console.log('[authDevice V1 params 01]:: ', { ...params, ...extra_params });

        return { ...params, ...extra_params };
    }

    success(data, b) {
        this.resolve(data);
    }

    getRetriesNumber() {
        return 0;
    }

    isValid(data) {
        console.log('[authDevice V1 isValid]:: ', data);
        if (data.errors || !data.data || data.data === 'errors') {
            return false;
        }

        return true;
    }
}

export default authdeviceV1Task;



// WEBPACK FOOTER //
// ./src/requests/tasks/user/authDeviceV1Task.js